import useKeyPress from '@umijs/hooks/es/useKeyPress'
import { Button } from 'antd'
import * as React from 'react'
import { useEffect, useRef, useState } from 'react'
// @ts-ignore
import { FroalaEditor } from './react-editor/FroalaEditor'

// Require Editor JS files.
import '@averystupidtest/editor/js/froala_editor.pkgd.min.js'
import '@averystupidtest/editor/js/plugins.pkgd.min.js'

import '@averystupidtest/editor/js/third_party/embedly.min.js'

// Require Editor CSS files.
import '@averystupidtest/editor/css/froala_editor.pkgd.min.css'
import '@averystupidtest/editor/css/froala_style.min.css'

import '@averystupidtest/editor/css/third_party/embedly.min.css'

import { parser } from './parser'
import { SecondToolbar } from './SecondToolbar'
import { RichTextEditorProps } from './types'

import * as styles from './RichTextEditor.module.less'

export const RichTextEditor: React.FC<RichTextEditorProps> = (props) => {
    const {
        content,
        getTributeComponent,
        onSave,
        placeholder,
        tributes
    } = props
    const initialContent = parser.dbToHtml(content, getTributeComponent) || ''
    const saveButtonTitle = props.saveButtonTitle || 'Save'

    const ref: any = useRef({ editor: null })
    const [isFroalaInitialized, setIsFroalaInitialized] = useState(false)
    const [editor, setEditor] = useState<any>(undefined)
    const [model, setModel] = useState<any>(initialContent)
    const [isSendButtonDisabled, setIsSendButtonDisabled] = useState(true)

    const onCancel = () => {
        props.onCancel && props.onCancel(parser.htmlToDb(editor.html.get()))
    }

    useKeyPress(['esc'], (event) => {
        props.onCancel && props.onCancel(parser.htmlToDb(editor.html.get()))
    })

    useEffect(() => {
        setModel(initialContent)
    }, [initialContent])

    const handleModelChange = (model: any) => {
        setModel(model)
    }

    const saveContent = () => {
        const content = parser.htmlToDb(editor.html.get())
        onSave && onSave(content)
    }

    const onSaveClicked = () => {
        saveContent()
    }

    const SecondToolbarRender = () => {
        const CancelButton = onCancel && (
            <Button type="default" onClick={onCancel}>
                Cancel
            </Button>
        )
        return (
            <SecondToolbar
                rightAlignedContent={
                    <React.Fragment>
                        {CancelButton}
                        <Button
                            type="primary"
                            disabled={isSendButtonDisabled}
                            onClick={onSaveClicked}
                            style={{ marginLeft: '1rem' }}
                        >
                            {saveButtonTitle}
                        </Button>
                    </React.Fragment>
                }
            />
        )
    }

    // Second Toolbar Container initialization

    // Editor initialization
    useEffect(() => {
        setEditor(ref.current.editor)
        editor && setIsFroalaInitialized(true)
    }, [ref.current])

    // component will unmount
    useEffect(() => {
        return () => {
            tributes &&
                tributes.map((tribute) => {
                    editor && tribute.detach(editor.el)
                })
        }
    }, [])

    // Do after initialization
    useEffect(() => {
        if (isFroalaInitialized) {
            tributes &&
                tributes.map((tribute) => {
                    tribute.attach(editor.el)
                })
            editor.html && editor.html.set(model)

            // Managed CTRL + Enter. Stops it and save the text.
            editor.events &&
                editor.events.on(
                    'keydown',
                    (e: any) => {
                        if ((e.which == '13' || e.which == '10') && e.ctrlKey) {
                            e.preventDefault()
                            e.stopPropagation()
                            e.stopImmediatePropagation()
                            saveContent()
                            return false
                        }
                    },
                    true
                )
        }
    }, [isFroalaInitialized, ref.current.editor, editor])

    useEffect(() => {
        setIsSendButtonDisabled(model === initialContent)
    }, [model, initialContent])

    return (
        <div className={styles.richTextEditor}>
            <FroalaEditor
                ref={ref}
                model={model}
                onModelChange={handleModelChange}
                tag="textarea"
                config={{
                    attribution: false,
                    placeholder: placeholder || 'Start typing...',
                    events: {
                        keydown: function (e: any) {
                            if (
                                (e.which == '13' || e.which == '10') &&
                                e.ctrlKey
                            ) {
                                e.preventDefault()
                                e.preventDefault()
                                e.stopPropagation()
                                e.stopImmediatePropagation()
                                saveContent()
                                return false
                            }
                        }
                    },
                    toolbarButtons: {
                        moreText: {
                            buttons: [
                                'bold',
                                'italic',
                                'underline',
                                'strikeThrough',
                                'subscript',
                                'superscript',
                                'fontFamily',
                                'fontSize',
                                'textColor',
                                'backgroundColor',
                                'inlineClass',
                                'inlineStyle',
                                'clearFormatting'
                            ]
                        },
                        moreParagraph: {
                            buttons: [
                                'alignLeft',
                                'alignCenter',
                                'formatOLSimple',
                                'alignRight',
                                'alignJustify',
                                'formatOL',
                                'formatUL',
                                'paragraphFormat',
                                'paragraphStyle',
                                'lineHeight',
                                'outdent',
                                'indent',
                                'quote'
                            ]
                        },
                        moreRich: {
                            buttons: [
                                'insertLink',
                                'insertImage',
                                'insertVideo',
                                'insertTable',
                                'emoticons',
                                'fontAwesome',
                                'specialCharacters',
                                'embedly',
                                'insertFile',
                                'insertHR'
                            ]
                        },
                        moreMisc: {
                            buttons: [
                                'undo',
                                'redo',
                                'fullscreen',
                                'print',
                                'getPDF',
                                'spellChecker',
                                'selectAll',
                                'html',
                                'help'
                            ],
                            align: 'right',
                            buttonsVisible: 2
                        }
                    }
                }}
            />
            <SecondToolbarRender />
            {/* {SecondToolbarRender(initialContent === model)} */}
        </div>
    )
}
